import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "../../../shared/language";

interface Props {
  display?: boolean;
  setDisplay?: any;
  config: {
    mode?: "substitute" | "adjustment";
    actionName?: string;
    title?: string;
  };
  onCreateInvoice?: any;
  onCreateInvoiceList?: any;
}

export const DialogCreateMultipleInvoiceOptions = ({
  display,
  setDisplay,
  config,
  onCreateInvoice,
  onCreateInvoiceList,
}: Props) => {
  const {t} = useTranslation();
  const isSubstitute = config.mode === "substitute" || config.actionName === "Thay thế";
  const actionName = t(isSubstitute ? "common.replace" : "common.adjust");
  const title = t(isSubstitute ? "common.replacement" : "common.adjustment");
  const close = () => setDisplay(false);

  return (
    <Dialog
      header={t("common.multipleInvoiceDialogHeader", {title})}
      visible={display}
      style={{ width: "47rem" }}
      draggable={false}
      resizable={false}
      onHide={close}
    >
      <div className="line-height-3 text-700">
        <div className="mb-3">
          {t("common.multipleInvoiceLegalNotice")}
        </div>

        <div
          className="border-round p-3 mb-3"
          style={{ backgroundColor: "#e8f4ff" }}
        >
          <div className="font-bold text-xl mb-3">
            {t("common.multipleInvoiceInstruction", {actionName})}
          </div>
          <div className="mb-3">
            {t("common.multipleInvoiceStep1", {title})}
          </div>
          <div>
            {t("common.multipleInvoiceStep2", {actionName})}
          </div>
        </div>

        <div>{t("common.askCreateInvoiceList")}</div>
      </div>

      <div className="flex justify-content-end align-items-center mt-5 gap-2">
        <Button label={t("common.cancel")} className="p-button-text" onClick={close} />
        <Button
          label={t("common.createInvoiceSkipList")}
          className="p-button-outlined"
          onClick={() => {
            close();
            onCreateInvoice?.();
          }}
        />
        <Button
          label={t("common.createInvoiceWithList")}
          onClick={() => {
            close();
            onCreateInvoiceList?.();
          }}
        />
      </div>
    </Dialog>
  );
};
